import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog';
import ContactForm from './ContactForm';

interface ContactFormDialogProps {
  children: React.ReactNode;
  open?: boolean;
  onOpenChange?: (_state: boolean) => void;
}

const ContactFormDialog = ({
  children,
  open,
  onOpenChange,
}: ContactFormDialogProps) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent className="sm:max-w-[800px] max-h-[90vh] overflow-y-auto bg-elev8-dark border-white/10">
        <DialogTitle className="sr-only">Contact Form</DialogTitle>
        <DialogDescription className="sr-only">
          Fill out the form to get in touch with ELEV8 Growth Solutions. Press
          Ctrl+Enter to submit.
        </DialogDescription>
        <ContactForm isDialog />
      </DialogContent>
    </Dialog>
  );
};

export default ContactFormDialog;
